export const environment = {
      production: false,
  apiHost:"http://localhost",
  apiPort: 3000,
  loginWithPassword: true
  };

